//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class ActivityNodeService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[ActivityNode.Create]
	async create(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/aut/activity-node/create', params || { });
	};

//GeneratorFlag:[NewAction]
}